import { useEffect } from "react";
import "./Insurance.css";
import NavUser from "../components/NavUser";
import SEO from "../components/SEO";
import { FaShieldAlt, FaInfoCircle, FaCheckCircle, FaStar } from "react-icons/fa";

function Insurance() {
  
  useEffect(() => {
    const src = "https://storage.googleapis.com/safetywing-static/widget/safetywing-price-widget.js";

    const getContainer = () => document.querySelector(".safetywing-price-widget");

    const c = getContainer();
    if (!c) {
      console.warn("SafetyWing: container element not found on mount.");
      return;
    }

    // If already initialized
    if (c.dataset.safetywingInitialized === "1") {
      console.log("SafetyWing: widget already initialized on container.");
      return;
    }

    // If another mount is already initializing this container, skip
    if (c.dataset.safetywingInitializing === "1") {
      console.log("SafetyWing: container is already initializing, skipping duplicate init.");
      return;
    }

    // Mark container as initializing and clear any previous content to prevent duplicates
    c.dataset.safetywingInitializing = "1";
    c.innerHTML = "";

    // If a global script load is in progress, wait for it and verify container afterward
    if (window.__safetywing_script_loading) {
      const onLoadedCheck = () => {
        if (c.children.length > 0 || c.style.width) {
          c.dataset.safetywingInitialized = "1";
          delete c.dataset.safetywingInitializing;
          console.log("SafetyWing: initialized after existing script load.");
        } else {
          // No widget yet; append another script to force run
          const retry = document.createElement("script");
          retry.src = src + "?_ts=" + Date.now();
          retry.async = true;
          document.body.appendChild(retry);
        }
      };
      window.addEventListener("safetywing-loaded", onLoadedCheck, { once: true });
      return;
    }

    // Otherwise initiate script load
    window.__safetywing_script_loading = true;
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.setAttribute("data-injected-by", "insurance-component");

    s.onload = () => {
      window.__safetywing_script_loading = false;
      window.__safetywing_script_loaded = true;
      window.dispatchEvent(new Event("safetywing-loaded"));

      // Allow the widget to render
      setTimeout(() => {
        if (c.children.length > 0 || c.style.width) {
          c.dataset.safetywingInitialized = "1";
          delete c.dataset.safetywingInitializing;
          console.log("SafetyWing: container found and script ran.", c);
        } else {
          delete c.dataset.safetywingInitializing;
          console.warn("SafetyWing: script loaded but widget did not initialize.");
        }
      }, 350);
    };

    s.onerror = (e) => {
      window.__safetywing_script_loading = false;
      delete c.dataset.safetywingInitializing;
      console.error("SafetyWing: script failed to load", e);
    };

    document.body.appendChild(s);

    return () => {
      // Clean up only scripts injected during this mount if the script never finished loading
      if (!window.__safetywing_script_loaded) {
        const injected = document.querySelectorAll('script[data-injected-by="insurance-component"]');
        injected.forEach(el => el.remove());
        window.__safetywing_script_loading = false;
      } else {
        // If loaded, just ensure we clear the initializing flag
        if (c && c.dataset.safetywingInitializing) delete c.dataset.safetywingInitializing;
      }
    };
  }, []);

  return (
    <div className="agent-page">
      <SEO 
        title="Travel & Medical Insurance for Sri Lanka Tourists"
        description="Comprehensive travel medical insurance and emergency coverage for international travelers and tourists visiting Sri Lanka."
        canonicalPath="/insurance"
      />
      <NavUser />
      
      <div className="agent-hero">
        <div className="agent-hero-overlay" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1436491865332-7a61a109c0f3?auto=format&fit=crop&w=1600&q=80')` }} />
        <div className="agent-hero-content">
          <h1>Travel Insurance</h1>
          <p>Secure your journey with world-class protection and peace of mind.</p>
        </div>
      </div>

      <div className="agent-container">
        <div className="insurance-grid">
          <div className="agent-card">
            <div className="section-title">
              <FaInfoCircle /> Why Travel Insurance?
            </div>
            <p className="premium-text">
              Travel insurance is essential for travelers, offering financial
              protection against unexpected events like medical emergencies, trip
              cancellations, and lost belongings. It ensures peace of mind, allowing
              you to fully enjoy your adventure without worrying about potential
              setbacks.
            </p>
          </div>

          <div className="agent-card">
            <div className="section-title">
              <FaShieldAlt /> Comprehensive Plan
            </div>
            <p className="premium-text">
              Protect your trip with our comprehensive travel insurance plan,
              designed to cover a wide range of unexpected events from medical care to travel delays.
            </p>
            <div className="plan-highlights">
              <div className="highlight-item"><FaCheckCircle /> Medical Coverage</div>
              <div className="highlight-item"><FaCheckCircle /> Emergency Evacuation</div>
              <div className="highlight-item"><FaCheckCircle /> Trip Cancellation</div>
              <div className="highlight-item"><FaCheckCircle /> Baggage Protection</div>
            </div>
          </div>
        </div>

        <div className="agent-card insurance-widget-card">
          <div className="recommended-badge"><FaStar /> Recommended</div>
          <div className="widget-header">
            <h3>SafetyWing Nomad Insurance</h3>
            <p>The most flexible insurance for world travelers.</p>
          </div>
          
          <div className="safetywing-wrapper">
            {/* SafetyWing Widget */}
            <div
              className="safetywing-price-widget"
              data-safetywingaffiliateid="26304559"
              data-scale="1.0"
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Insurance;
